/**
 * Decodes JWT token payload (client-side only, no verification)
 */
const decodeJWT = (token: string): any => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }
    
    const payload = parts[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    return null;
  }
};

/**
 * Checks if JWT token is expired
 */
const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = decodeJWT(token);
    if (!decoded || !decoded.exp) {
      return true; // Consider expired if no expiration
    }
    
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
  } catch (error) {
    return true; // Consider expired if error
  }
};

export default (item: string) => {
  try {
    const storedItem = localStorage.getItem(item);
    if (!storedItem) {
      return null;
    }
    
    const parsed = JSON.parse(storedItem);
    
    // Additional validation for user object
    if (item === 'user' && parsed) {
      // Check if user object has required fields
      if (!parsed.access || !parsed.pk || !parsed.name) {
        console.warn('Invalid user object in localStorage, removing it');
        localStorage.removeItem(item);
        return null;
      }
      
      // Check if access token is not expired
      if (parsed.access && typeof parsed.access === 'string') {
        try {
          // Basic JWT structure check (has 3 parts separated by dots)
          const parts = parsed.access.split('.');
          if (parts.length !== 3) {
            console.warn('Malformed access token, removing user data');
            localStorage.removeItem(item);
            return null;
          }
          
          // Check if token is expired
          if (isTokenExpired(parsed.access)) {
            console.warn('Access token is expired, removing user data');
            localStorage.removeItem(item);
            return null;
          }
        } catch (error) {
          console.warn('Error validating access token, removing user data');
          localStorage.removeItem(item);
          return null;
        }
      }
    }
    
    return parsed;
  } catch (err) {
    console.error(`Error parsing ${item} from localStorage:`, err);
    localStorage.removeItem(item);
    return null;
  }
};
